<section class="course-certificate">
  <div class="course-certificate__icon" aria-hidden="true">🎓</div>
  <h3 class="course-certificate__title">{{ 'app.components.courseCertificate.title' | translate }}</h3>
  <p class="course-certificate__description">{{ 'app.components.courseCertificate.description' | translate }}</p>
</section>
